"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SitecoreContext_1 = require("../components/SitecoreContext");
function withComponentFactory(Component) {
    return function WithComponentFactory(props) {
        return (react_1.default.createElement(SitecoreContext_1.ComponentFactoryReactContext.Consumer, null, function (context) { return react_1.default.createElement(Component, __assign({}, props, { componentFactory: props.componentFactory || context })); }));
    };
}
exports.withComponentFactory = withComponentFactory;
